import React, { useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";

// Check session storage data
const checkSessionStorage = () => {
    const username = sessionStorage.getItem("username");
    const email = sessionStorage.getItem("email");
    const jwt = sessionStorage.getItem("jwt");
    return username && email && jwt;
};

// Protected route wrapper
const withAuth = (WrappedComponent) => {
    const AuthenticatedComponent = (props) => {
        const navigate = useNavigate();
        const isAuthenticated = checkSessionStorage();

        useEffect(() => {
            // Additional auth checks can go here (e.g., token validation)
            if (!isAuthenticated) {
                navigate("/login", { replace: true });
            }
        }, [isAuthenticated, navigate]);

        // Immediately redirect if not authenticated
        if (!isAuthenticated) {
            return <Navigate to="/login" replace />;
        }

        // Render component only when authenticated
        return <WrappedComponent {...props} />;
    };

    return AuthenticatedComponent;
};

export { checkSessionStorage };
export default withAuth;